import { render, staticRenderFns } from "./EnderecoCidadeField.vue?vue&type=template&id=4742c551&scoped=true&"
import script from "./EnderecoCidadeField.vue?vue&type=script&lang=js&"
export * from "./EnderecoCidadeField.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoCidadeField.vue?vue&type=style&index=0&id=4742c551&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742c551",
  null
  
)

export default component.exports